import { useMemo, useState } from 'react';
import i18n from '../../../../i18n';
import {
    buildVariantAttributeContext,
    getSelectedVariant,
    selectVariantAttribute,
} from '../ProductStoreOverview/variantUtils';
import ProductVariantSelector from '../ProductVariantSelector/ProductVariantSelector';

const CompositionVariantPicker = ({ group, onChange }) => {
    const parent = group.variant_parent;
    const product = useMemo(
        () => ({
            attribute_objects: parent.attribute_objects || [],
            product_objects: parent.product_objects || parent.child_products || [],
        }),
        [parent]
    );
    const { attrMap, attrs } = useMemo(() => {
        const ctx = buildVariantAttributeContext(product);
        return { attrMap: ctx.attrMap, attrs: ctx.attrs };
    }, [product]);
    const [selectedVariant, setSelectedVariant] = useState({});

    return (
        <ProductVariantSelector
            size="detail"
            title={group.label}
            product={product}
            attrs={attrs}
            attrMap={attrMap}
            selectedVariant={selectedVariant}
            onSelect={(shortCode, valueId) => {
                const next = selectVariantAttribute(
                    product,
                    attrMap,
                    attrs,
                    selectedVariant,
                    shortCode,
                    valueId,
                );
                setSelectedVariant(next);
                const match = getSelectedVariant(product, next, attrMap);
                if (match?.product_object?.id) {
                    onChange(group.choice_group, match.product_object.id);
                }
            }}
        />
    );
};

const CompositionChoiceGroups = ({ groups, selections, onChange }) => {
    if (!groups?.length) return null;

    return (
        <div className="composition-choice-groups">
            <h6 className="composition-choice-groups__title">{i18n.t('Configure your box')}</h6>
            {groups.map((group) => {
                if (group.variant_parent) {
                    return (
                        <CompositionVariantPicker
                            key={group.choice_group}
                            group={group}
                            onChange={onChange}
                        />
                    );
                }
                return (
                    <ProductVariantSelector
                        key={group.choice_group}
                        size="detail"
                        groups={[{
                            key: group.choice_group,
                            name: group.label,
                            options: (group.options || [])
                                .filter((opt) => !opt.is_variant_parent)
                                .map((opt) => ({
                                    id: opt.component_product_id,
                                    label: opt.component_product_name,
                                    selected: selections[group.choice_group] === opt.component_product_id,
                                    compatible: true,
                                })),
                        }]}
                        onSelect={(groupKey, productId) => onChange(groupKey, productId)}
                    />
                );
            })}
        </div>
    );
};

export default CompositionChoiceGroups;
